import { metrics } from '@seek/metrics-js';
import { TextLink } from 'braid-design-system';
import React from 'react';

import { Link } from 'src/components/Router/Link';
import type { AnalyticsActionOrigin } from 'src/modules/analytics/types';
import { useIsShareableProfileFeatureActive } from 'src/modules/features/shareableProfileAbTest';
import { useTypedSelector } from 'src/modules/hooks/useTypedSelector';

const nudgeClicked = () =>
  metrics.count('nudge_action', ['id:profile-visibility']);

export const ProfileVisibilityNudgeLink = ({
  text,
  analytics,
}: {
  text: string;
  analytics?: { origin: AnalyticsActionOrigin };
}) => {
  const isCreateResumePage = useTypedSelector(
    (state) => state.router.page === 'create-resume-page',
  );

  const { isShareableProfileFeatureActive } =
    useIsShareableProfileFeatureActive();

  const profileVisibilityLink = isShareableProfileFeatureActive
    ? 'profile-visibility-v2'
    : 'profile-visibility';

  const profileVisibilityMode = isShareableProfileFeatureActive
    ? 'EDIT'
    : 'READ';

  return (
    <Link
      to={profileVisibilityLink}
      mode={profileVisibilityMode}
      {...(isCreateResumePage ? { page: 'profile-page' } : {})}
      component={TextLink}
      onClick={nudgeClicked}
      params={{ focusOn: 'level' }}
      hitArea="large"
      weight="weak"
      analytics={analytics}
    >
      {text}
    </Link>
  );
};
